import type { SxProps, Theme } from '@mui/material/styles';

export const previewDockSx = (previewOnly: boolean): SxProps<Theme> => ({
  '&.MuiDialog-container': {
    alignItems: previewOnly ? 'flex-end' : undefined,
  },
});

export const previewDockPaperSx = (previewOnly: boolean) => (
  previewOnly ? { mb: { xs: 7, sm: 4 } } as const : {}
);
